const ModelRepairData = {
  inputData: [
    {
      id: 0,
      fileId: 0,
      variableName: "grade_prompt",
      userInput: "",
      correct_expression: "True",
      validate_expression: "^(True|False)$",
    },
  ],
};

export default ModelRepairData;
